import { styled, Typography } from '@mui/material';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Card, CardContent } from 'further-ui/components/Card';
import { Column } from 'further-ui/components/Layout';
import { round } from 'lodash';

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  height: '100%',
}));

const CenteredCardContent = styled(CardContent)({
  height: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

type Props = {
  sourceCurrency: CurrencyCode;
  targetCurrency: CurrencyCode;
  rate: number;
};

const CurrencyTransactionRate: React.FC<Props> = ({
  sourceCurrency,
  targetCurrency,
  rate,
}) => {
  return (
    <Column fullWidth>
      <StyledCard variant="outlined">
        <CenteredCardContent size="sm">
          <Column spacing="xxs" centered justify="center">
            <Typography variant="h6">Rate at transfer</Typography>
            <Typography variant="body2">
              {`1 ${sourceCurrency} = ${round(rate, 6).toFixed(
                6,
              )} ${targetCurrency}`}
            </Typography>
          </Column>
        </CenteredCardContent>
      </StyledCard>
    </Column>
  );
};

export default CurrencyTransactionRate;
